import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Store/StoreFinderHeaderButton/storeFinderHeaderButton.container"
    ).then((module) => ({
        default: module.StoreFinderHeaderButtonContainer
    }))
);
